import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SeoHead from '../seo/SeoHead';
import { PAGES, BUSINESS } from '../seo/businessConfig';
import { pageBreadcrumbs, buildOfferCatalogSchema } from '../seo/schema';
import { Link } from 'react-router-dom';

function Cennik() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const page = PAGES.cennik;

  return (
    <div className="relative bg-primary-olive min-h-screen">
      <SeoHead
        title={page.title}
        description={page.description}
        keywords={page.keywords}
        path={page.path}
        jsonLd={[pageBreadcrumbs('cennik'), buildOfferCatalogSchema()]}
      />
      <Navbar />
      <main className="pt-32 md:pt-48 pb-20 px-6 md:px-12 max-w-5xl mx-auto">
        <header className="mb-12 md:mb-20">
          <h1 className="text-5xl md:text-7xl font-bold text-primary tracking-wide">
            Cennik
            <span className="text-primary opacity-50">/</span>
          </h1>
          <p className="mt-4 text-primary text-lg md:text-xl max-w-2xl leading-relaxed">
            Aktualne ceny noclegów w Zaciszu Czarna Owca — Brzeżanka / Strzyżów. Ceny w PLN za dobę.
          </p>
        </header>

        <article className="bg-primary-bright bg-opacity-40 p-8 md:p-12 lg:p-16 rounded-xl shadow-lg text-primary text-lg md:text-xl leading-relaxed space-y-8 font-medium">
          <h2 className="text-2xl md:text-3xl font-bold">Ceny pokoi</h2>
          <ul className="list-none space-y-4">
            {BUSINESS.rooms.map((room) => (
              <li
                key={room.name}
                className="flex flex-col sm:flex-row sm:justify-between sm:items-baseline border-b border-primary/20 pb-3"
                itemScope
                itemType="https://schema.org/Offer"
              >
                <span itemProp="name" className="font-bold">
                  {room.name}
                </span>
                <span>
                  <meta itemProp="priceCurrency" content="PLN" />
                  <span itemProp="price" content={String(room.price)} className="text-2xl font-extrabold">
                    {room.price} zł
                  </span>
                  <span className="text-base opacity-70"> / doba</span>
                </span>
              </li>
            ))}
          </ul>

          <p>
            W przypadku pobytu jednodniowego cena wzrasta o <strong>10%</strong>.
          </p>

          <section aria-labelledby="exclusive-heading">
            <h2 id="exclusive-heading" className="text-2xl md:text-3xl font-bold mb-3">
              Wyłączność obiektu
            </h2>
            <p>
              Istnieje możliwość organizowania wieczorów kawalerskich i panieńskich z wyłącznością
              całego domku. Cena za jednodniowy pobyt:{' '}
              <strong>{BUSINESS.exclusiveOffer.price} zł</strong> + kaucja{' '}
              <strong>{BUSINESS.exclusiveOffer.deposit} zł</strong>.
            </p>
          </section>

          <p className="pt-4">
            Rezerwacje:{' '}
            <a className="underline font-bold" href={`tel:${BUSINESS.telephone}`}>
              {BUSINESS.telephoneDisplay}
            </a>{' '}
            ·{' '}
            <Link to="/kontakt" className="underline font-bold">
              formularz kontaktu
            </Link>
          </p>
        </article>
      </main>
      <Footer />
    </div>
  );
}

export default Cennik;
